<form [formGroup]="orgForm" (ngSubmit)="updateOrgDetails()" class="grid grid-cols-12 gap-x-6 w-full p-4" 
*ngIf="!isInitialLoading"
>

    <!-- Input Fields -->
    <div class="col-span-9">
        <div class="p-fluid flex flex-col gap-6">

            <!-- Dynamic Fields -->
            <div
                *ngFor="let field of ['Name', 'Type', 'Address', 'City', 'State', 'Country', 'Contact_number', 'Email', 'Website', 'Registration_number', 'Accreditation', 'Institution_code', 'Bot_client_id']">
                <label [for]="field" class="block mb-2 text-sm font-semibold text-gray-700">
                    {{ field.replace('_', ' ') }}
                </label>
                <input pInputText [formControlName]="field" [id]="field"
                    class="w-full rounded-md border border-gray-300 shadow-sm focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />

                    <div *ngIf="(orgForm.get('Name')?.invalid && (orgForm.get('Name')?.touched)) && field == 'Name'" class="text-red-500 text-xs mt-1">
                        Name is required.
                    </div>
                    <div *ngIf="(orgForm.get('Type')?.invalid && (orgForm.get('Type')?.touched)) && field == 'Type'" class="text-red-500 text-xs mt-1">
                        Type is required.
                    </div>
                    
                    <div *ngIf="(orgForm.get('Email')?.invalid && (orgForm.get('Email')?.touched)) && field == 'Email'" class="text-red-500 text-xs mt-1">
                        Invalid email format.
                    </div>
            </div>

          


            <!-- Postal Code -->
            <div>
                <label for="Postal_code" class="block mb-2 text-sm font-semibold text-gray-700">
                    Postal Code
                </label>
                <input type="number" pInputText inputId="Postal_code" [formControlName]="'Postal_code'" mode="decimal"
                    class="w-full rounded-md border border-gray-300 shadow-sm focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
            </div>

            <!-- Establishment Year -->
            <div>
                <label for="Establishment_year" class="block mb-2 text-sm font-semibold text-gray-700">
                    Establishment Year
                </label>
                <input type="number" pInputText inputId="Establishment_year" [formControlName]="'Establishment_year'"
                    mode="decimal"
                    class="w-full rounded-md border border-gray-300 shadow-sm focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
            </div>

            <!-- Status -->
            <div>
                <label for="Status" class="block mb-2 text-sm font-semibold text-gray-700">
                    Status
                </label>
                <p-select [options]="statusOptions" formControlName="Status" placeholder="Select a status"
                    inputId="Status"
                    class="w-full rounded-md border border-gray-300 shadow-sm focus:ring-2 focus:ring-primary-500 focus:border-primary-500">
                </p-select>

                <div *ngIf="orgForm.get('Status')?.touched && orgForm.get('Status')?.hasError('required')"
                    class="text-red-500 text-xs mt-1">
                    Status is required.
                    </div>
            </div>

            <!-- Submit Button -->
            <div class="flex justify-end mt-4">
                <button pButton type="submit" 
                [loading]="isUpdating"
                [disabled]="isUpdating"
                label="Update" icon="pi pi-check" [style]="{ 'width': '100%' }"
                    class="rounded-lg px-6 py-3 font-semibold text-white transition-all duration-300"></button>
            </div>

        </div>
    </div>


    <!-- Image Upload Section -->

    <div class="col-span-3 flex flex-col items-center">
        <div *ngIf="imageUrl; else placeholder">
            <img [src]="imageUrl" class="w-32 h-32 rounded-full border mb-4" alt="Logo" />
        </div>
        <ng-template #placeholder>
            <div class="w-32 h-32 rounded-full border flex items-center justify-center text-gray-400 mb-4">
                No Image
            </div>
        </ng-template>

        <input type="file" #fileInput accept="image/*" hidden (change)="handleFileChange($event)" />

        <button type="button"
            class="bg-yellow-400 hover:bg-yellow-500 text-black px-4 py-2 rounded font-semibold shadow"
            (click)="fileInput.click()">
            ⬆ Upload
        </button>

        <button type="submit" class="mt-4 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded">
            📝 Update Detail
        </button>
    </div>

</form>

<div *ngIf="isInitialLoading" class="flex justify-center items-center h-[80vh]">
    <p-progressSpinner></p-progressSpinner>
</div>